import { Box } from '@bonanza-social/moonlight';
import { memo, useMemo, useState } from 'react';
import TabsSection from './TabSection/TabsSection';
import { InviteFriendsScreens } from './InviteFriendsComponent.types';
import InviteFriends from './InviteFriends/InviteFriends';
import Terms from './Terms/Terms';

function InviteFriendsComponent() {
  const [screen, setScreen] = useState<InviteFriendsScreens>(
    InviteFriendsScreens.INVITE_FRIENDS,
  );

  const ScreenComponent = useMemo(() => {
    if (screen === InviteFriendsScreens.INVITE_FRIENDS) {
      return InviteFriends;
    }

    return Terms;
  }, [screen]);

  return (
    <Box
      gap="space-400"
      paddingLeft="space-400"
      paddingRight="space-400"
      flex={1}
    >
      <TabsSection setScreen={setScreen} />
      <ScreenComponent />
    </Box>
  );
}

export default memo(InviteFriendsComponent);
